// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"38b547c5","138":"6b484fb3","254":"367cfba2","287":"65d71891","699":"a1830d16","717":"7fd1675a","787":"d5955df0"}[chunkId] + ".chunk.js";
};